<button type="button" class="btn btn-sm btn-info" (click)="openVorlagenPopup()"><span>Vorlagen <span
      title="Auswahl einer Vorlage für diesen Bereich, die automatisch mit Daten befüllt wird."
      class="text-danger glyphicon glyphicon-question-sign"></span></span></button>

<dx-popup title="Vorlagen Auswahl" [width]="'600px'" [height]="'500px'" [(visible)]="isPopupVisible"
  style="display: inline-block;">
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView id="scrollview" [scrollByContent]="true" [scrollByThumb]="true"
      [showScrollbar]="'onHover'" reachBottomText="Updating...">
      <div class="row">
        <div class="col-md-12 well">
          <dx-list [items]="items" [selectionMode]="'single'" #vorlagenList>
            <div *dxTemplate="let item of 'item'">
              {{item.name}}
            </div>
          </dx-list>
        </div>
        <div class="row" style="padding-top:20px;">
          <div class="col-md-12 text-center">
            <button type="button" class="btn btn-info" (click)="createDocument()"
              [disabled]="!vorlagenList.selectedItems[0]"><span>Dokument erstellen</span></button>
          </div>
        </div>
      </div>
    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
            text: 'Schließen',
            onClick: hidePopup
        }">
  </dxi-popup-toolbar-item>
</dx-popup>



<dx-popup title="Dynamische-Platzhalter befüllen" [width]="'600px'" [height]="'500px'" [(visible)]="isPlatzhalterPopupVisible"
  style="display: inline-block;">
  <div *dxTemplate="let data of 'content'">
    <dx-scroll-view #scrollView id="scrollview" [scrollByContent]="true" [scrollByThumb]="true"
      [showScrollbar]="'onHover'" reachBottomText="Updating...">
      
      <div class="row mrl">
        <div class="col-md-12">
          <dx-validation-group #platzhalterTargetGroup>

            <div class="dx-field" *ngFor="let item of vorlagenList.selectedItems[0].platzhalter">
              <div class="dx-field-label w100">
                <span class="dx-field-item-label-content" style="width: 75px;">
                  <span class="dx-field-item-label-text">{{item.name}}&nbsp;&nbsp;[{{item.key}}]:</span>
                  <span class="dx-field-item-required-mark" *ngIf="item.required">&nbsp;*</span>
                </span>
              </div>
              <div class="dx-field-value w100">
                <dx-text-box  [(value)]="item.default">
                  <dx-validator *ngIf="item.required">
                      <dxi-validation-rule type="required">
                      </dxi-validation-rule>
                  </dx-validator>
              </dx-text-box>
              </div>
          </div>


         
           
        </dx-validation-group>

        </div>
       
      </div>


    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
            text: 'Ok',
            onClick: onPlatzhalterPopupOk
        }">
</dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
            text: 'Schließen',
            onClick: hidePlatzhalterPopup
        }">
  </dxi-popup-toolbar-item>
</dx-popup>

<dx-popup title="Vorlagen wird zusammengestellt!" [width]="'50%'" [height]="'auto'" [(visible)]="isWaitPopupVisible"
  style="display: inline-block;">
  <div *dxTemplate="let data of 'content'">
    <div class="row" style="padding-top:20px;">
      <div class="col-md-12 text-center">
        <h1 class="text-danger">Bitte warten bis Download abgeschlossen wurde.</h1>
      </div>
    </div>
  </div>
</dx-popup>